import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import ProposalsEditDetailsStore, { ProposalsEditDetailsStoreProvider } from "./ProposalsEditDetailsStore"
import useStore from "reusable/mobx-store-utils"
import { useProposalsEditStore } from "../ProposalsEditStore"
import ProposalsEditDetailsTOE from "./ProposalsEditDetailsTOE"
import ProposalsEditDetailsTiming from "./ProposalsEditDetailsTiming"
import ProposalsEditDetailsSignees from "./ProposalsEditDetailsSignees"
import ProposalsEditDetailsDueDate from "./ProposalsEditDetailsDueDate"
import useInitialMount from "reusable/hooks/useInitialMount"
import ProposalsEditDetailsObjectivesAndValue from "./ProposalsEditDetailsObjectivesAndValue"
import ProposalsEditDetailsExpectations from "./ProposalsEditDetailsExpectations"

export default observer(function ProposalsEditDetails() {
   const proposalsEditStore = useProposalsEditStore()
   const proposalsEditDetailsStore = useStore((sp) => new ProposalsEditDetailsStore(sp), { proposalsEditStore })

   useInitialMount(() => {
      proposalsEditDetailsStore.fetch()
   })

   return <ProposalsEditDetailsStoreProvider store={proposalsEditDetailsStore}>
      <Box>
         <Typography variant="h4">Details & Terms</Typography>
         <Typography variant="body1" sx={{ mt: 2 }}>Provide more details about this proposal and upload any terms.</Typography>
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsObjectivesAndValue />
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsExpectations />
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsTiming />
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsTOE />
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsSignees />
      </Box>

      <Box sx={{ mt: 8 }}>
         <ProposalsEditDetailsDueDate />
      </Box>
   </ProposalsEditDetailsStoreProvider>
})
